import { render, staticRenderFns } from "./Attraction.vue?vue&type=template&id=c0770006&scoped=true"
import script from "./Attraction.vue?vue&type=script&lang=js"
export * from "./Attraction.vue?vue&type=script&lang=js"
import style0 from "./Attraction.vue?vue&type=style&index=0&id=c0770006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0770006",
  null
  
)

export default component.exports